<template>
  <div
    class="z-spin"
    :class="{
      'z-spin-fix': fix,
      'z-spin-show-text': custom,
      'z-spin-fullscreen': fullscreen,
      'z-spin-small': size === 'small',
      'z-spin-large': size === 'large',
    }"
    :style="{ backgroundColor: backgroundColor }"
  >
    <div class="z-spin-main">
      <div class="z-spin-dot"></div>
      <div class="z-spin-text">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // small || default || large
    size: {
      type: String,
      value: 'default',
    },
    fix: {
      type: Boolean,
      value: false,
    },
    fullscreen: {
      type: Boolean,
      value: false,
    },
    custom: {
      type: Boolean,
      value: false,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.z-spin {
  color: #2d8cf0;
  vertical-align: middle;
  text-align: center;
  .z-spin-dot {
    position: relative;
    display: block;
    border-radius: 50%;
    background-color: #349399;
    width: 40px;
    height: 40px;
    animation: ani-spin-bounce 1s 0s ease-in-out infinite;
  }
  .z-spin-text {
    display: block;
    font-size: 28px;
    color: #333333;
  }

  &.z-spin-large {
    .z-spin-dot {
      width: 64px;
      height: 64px;
    }
  }

  &.z-spin-small {
    .z-spin-dot {
      width: 24px;
      height: 24px;
    }
  }

  &.z-spin-fix {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4);
    .z-spin-main {
      position: absolute;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
    .z-spin-dot {
      display: inline-block;
    }
  }

  &.z-spin-fullscreen {
    z-index: 99999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.4);
    .z-spin-main {
      position: absolute;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
    .z-spin-dot {
      display: inline-block;
    }
  }

  &.z-spin-show-text {
    .z-spin-dot {
      display: none;
    }
  }

  @keyframes ani-spin-bounce {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
}
</style>
